import React from "react";
import { Td, ButtonLabel, TdCenter } from "../style/Table.style";
import { ImageVideoCard } from "./ImageVideoCard";
import { ToggleSwitch } from "./ToggleSwitch";
import { FlexContainer } from "src/components";
import drag_and_drop from "src/img/bodyAndMind/drag-and-drop.png";
import { getVisibilityLabel } from "../../hooks/getVisibilityLabel";
import { VideoCard, Card } from "./VideoCard";
import { LottieLoadingIndicator } from "src/components";
import { isVideoThumbnail } from "../utils/VideoUtils";

export const ManageCategoryRows = ({
    tableData,
    manageCategory,
    onShow,
    isItemShow,
    handleDragStart,
    handleDragEnter,
    handleDragEnd,
    handleDragOver,
    draggingIndex,
    hoveredIndex,
}) => {
    const renderRow = (item, index) => (
        <tr
            key={index}
            draggable
            onDragStart={() => handleDragStart(index)}
            onDragEnter={() => handleDragEnter(index)}
            onDragEnd={handleDragEnd}
            onDragOver={() => handleDragOver(index)}
            style={{
                backgroundColor: index === draggingIndex ? "#f0f8ff" : "#fff",
                opacity: index === draggingIndex ? 0.7 : 1,
                boxShadow: index === draggingIndex ? "0 2px 6px rgba(0, 0, 0, 0.2)" : "",
                zIndex: index === draggingIndex ? 10 : 0,
                position: index === draggingIndex ? "relative" : "",
                cursor: "grab",
                transition: "background-color 0.2s ease",
            }}
        >
            <TdCenter
                padding="0"
                align="center"
                style={{ borderTop: index === hoveredIndex ? "2px solid blue" : "" }}
            >
                <img
                    src={drag_and_drop}
                    alt="Arrow up down"
                    style={{ height: "40px", width: "30px", objectFit: "cover" }}
                    draggable={false}
                />
            </TdCenter>
            <TdCenter style={{ borderTop: index === hoveredIndex ? "2px solid blue" : "" }}>
                <FlexContainer direction="row" gap="12.75px">
                    <ImageVideoCard
                        src={item?.iconUrl}
                        loading={!item?.iconUrl}
                        styles={{
                            borderRadius: "99px",
                            height: "47px",
                            width: "46.74px",
                        }}
                    />
                    {item?.pendingMedia && isVideoThumbnail(item?.headerVideoUrl) ? (
                        <Card>
                            <div
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <LottieLoadingIndicator width="30px" height="30px" style={{ marginTop: "-23px" }} />
                            </div>
                        </Card>
                    ) : (
                        <VideoCard src={item?.videoThumbnailUrl} />
                    )}

                </FlexContainer>
            </TdCenter>
            <Td
                style={{
                    borderTop: index === hoveredIndex ? "2px solid blue" : "",
                    padding: "20px",
                    width: "150px",
                }}
            >
                {item.name}
            </Td>

            <Td
                style={{
                    borderTop: index === hoveredIndex ? "2px solid blue" : "",
                    padding: "20px",
                    width: "100px",
                }}
            >
                {item.postsCount ?? 0}
            </Td>
            <Td
                style={{
                    borderTop: index === hoveredIndex ? "2px solid blue" : "",
                    padding: "20px",
                    width: "100px",
                }}
            >
                {item.subcategoriesCount}
            </Td>
            <Td
                style={{
                    borderTop: index === hoveredIndex ? "2px solid blue" : "",
                    wordWrap: "break-word",
                    overflowWrap: "break-word",
                    whiteSpace: "normal",
                    padding: "20px",
                }}
            >
                {getVisibilityLabel(item.visibleTo)}
            </Td>
            <Td
                style={{
                    borderTop: index === hoveredIndex ? "2px solid blue" : "",
                    wordWrap: "break-word",
                    overflowWrap: "break-word",
                    whiteSpace: "normal",
                    width: "100px",
                    textAlign: "center",
                    justifyContent: "center",
                    alignContent: "center",
                }}
            >
                {item.companyUuid ? (
                    <ButtonLabel
                        onClick={() => {
                            manageCategory.toggleEditCategory();
                            manageCategory.setSelectedCategory(item);
                        }}
                    >
                        View/Edit
                    </ButtonLabel>
                ) : (
                    "Me Business Category"
                )}
            </Td>
            <TdCenter style={{ borderTop: index === hoveredIndex ? "2px solid blue" : "" }}>
                <ToggleSwitch onChange={() => onShow(item)} checked={!isItemShow(item.uuid)} />
            </TdCenter>
        </tr>
    );

    const renderEmpty = () => {
        const emptyRows = 10 - tableData.length;
        if (emptyRows < 1) return null;

        return Array.from({ length: emptyRows }, (_, i) => (
            <tr key={"empty_" + i}>
                {Array.from({ length: 8 }, (_, j) => (
                    <Td key={`empty_cell_${i}_${j}`} paddingLeft="0" align="center">
                        &nbsp;
                    </Td>
                ))}
            </tr>
        ));
    };

    return (
        <>
            {tableData.map(renderRow)}
            {renderEmpty()}
        </>
    );
};
